import { createActions } from '../utils/actions';

const { actions: profilesV2 } = createActions('profilesV2')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('connectListings')
  .addAsync('copyProfile')
  .addAsync('deleteProfile')
  .addAsync('disconnectListing')
  .add('edit')
  .addAsync('getAiOperations')
  .addAsync('getFilters')
  .addAsync('getListings')
  .addAsync('getProfiles')
  .addAsync('getTemplates')
  .addAsync('saveProfile')
  .add('search')
  .add('setData')
  .add('setModal')
  .add('setPage')
  .add('setSection')
  .add('setType')
  .addAsync('showConnectModal');

export default profilesV2;
